<template>
    <div class="border bg-blue-100 rounded p-4 mt-3">
        <div class="mb-4">Tiles</div>
        <draggable
            v-model="items"
            ghost-class="bg-gray-200"
            handle=".handle"
            @choose="froalaStore.disableFroala = true"
            @unchoose="froalaStore.disableFroala = false"
        >

            <div v-for="(item, index) in items" class="flex">
                <div class="ml-4 handle mt-2 float-left text-gray-400" title="Drag to reorder items">
                    <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 17l-4 4m0 0l-4-4m4 4V3" />
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 7l4-4m0 0l4 4m-4-4v18" />
                    </svg>
                </div>

               <div class="float-right mb-8 w-full ml-3">
                    <input-text
                        v-if="documentType == 'App\\Models\\HomePage'"
                        label="* Tile Title"
                        name="title"
                        v-model="item.title"
                        class="mt-3"
                        :maxlength=255
                        :error="errors['atf_tile.items.' + index + '.title'] ? errors['atf_tile.items.' + index + '.title'][0] : null"
                    />

                    <media-reference
                        v-model="item.background_image"
                        :language="language"
                        name="background"
                        class="mt-3"
                        label="Background"
                        :error="errors['atf_tile.items.' + index + '.image_id'] ? errors['atf_tile.items.' + index + '.image_id'][0] : null"
                        @input="updateBackgroundImage($event, index)"
                    />

                    <div
                        class="border bg-white rounded-lg p-4 shadow-sm max-w-2xl w-[49%] float-left mt-3"
                    >
                        <p class="text-gray-700 mb-4">* Casino</p>
                        <reference
                            create-text="Create new casino and link casino to this page"
                            link-text="Link an existing casino"
                            :language="language"
                            v-model="item.casino"
                            model-data="Casino"
                            :should-open-new-window="true"
                            :error="errors['atf_tile.items.' + index + '.casino_id'] ? errors['atf_tile.items.' + index + '.casino_id'][0] : null"
                            :creatable="false"
                            :query="{
                                'casinoReview.status_id': 1
                            }"
                            :order="{
                                'name': 'asc'
                            }"
                            @input="updateCasino($event, index)"
                        />
                    </div>

                    <div
                        class="border bg-white rounded-lg p-4 shadow-sm max-w-2xl w-[49%] float-right mt-3"
                    >
                        <p class="text-gray-700 mb-4">* Bonus</p>
                        <reference
                            create-text="Create new bonus and link bonus to this page"
                            link-text="Link an existing bonus"
                            :language="language"
                            v-model="item.bonus"
                            model-data="Bonus"
                            :should-open-new-window="true"
                            :error="errors['atf_tile.items.' + index + '.bonus_id'] ? errors['atf_tile.items.' + index + '.bonus_id'][0] : null"
                            :creatable="false"
                            :query="{
                                'casino_id': item.casino_id
                            }"
                            :order="{
                                'name': 'asc'
                            }"
                            @input="updateBonus($event, index)"
                        />
                    </div>
                </div>
            </div>
        </draggable>
    </div>
</template>

<script>
import draggable from "vuedraggable";
import siteLanguage from '../config/siteLanguage'
import {useFroalaStore} from "../stores/froala";

export default {
    components: { draggable },
    name: "AtfTileItems",
    props: {
        value: [Object, Array],
        documentType: {
            type: String,
            required: true
        },
        tilesCount: {
            type: Number,
            required: true
        },
        errors: {
            type: [Array, Object],
            required: true,
        },
        language: {
            type: Object,
            default: () => {
                return { iso: siteLanguage.iso.ENGLISH };
            }
        }
    },
    data() {
        return {
            items: this.value?.length ? this.value : this.defaultData(),
            froalaStore: useFroalaStore(),
        };
    },
    updated() {
        this.$emit("input", this.items);
    },
    methods: {
        defaultData() {
            let items = [];
            for(let i = 0; i < this.tilesCount; i++) {
                items.push({
                    background_image: null,
                    background_image_id: null,
                    casino: null,
                    casino_id: null,
                    bonus: null,
                    bonus_id: null
                });
            }
            this.$emit("input", items);
            return items;
        },
        updateBackgroundImage: function (image, index) {
            this.items[index].background_image_id = (image && image.id) ? image.id : null
        },
        updateCasino: function (casino, index) {
            if (casino && casino.id) {
                this.items[index].casino_id = casino.id
            } else {
                this.items[index].casino_id = null
                this.items[index].bonus = null
                this.items[index].bonus_id = null
            }
        },
        updateBonus: function (bonus, index) {
            this.items[index].bonus_id = (bonus && bonus.id) ? bonus.id : null
        }
    }
};
</script>
